import { AxiosRequestConfig } from "axios";
import { getAxiosInstance, requestConfig } from "../../http-common";
import { CreateEntityRequest } from "../../models/entities/CreateEntityRequest";
import { DeleteEntityRequest } from "../../models/entities/DeleteEntityRequest";
import { UpdateEntityRequest } from "../../models/entities/UpdateEntityRequest";
import { CreateFieldRequest } from "../../models/fields/CreateFieldRequest";
import { DeleteFieldRequest } from "../../models/fields/DeleteFieldRequest";
import { GetFieldsRequest } from "../../models/fields/GetFieldsRequest";
import { UpdateFieldRequest } from "../../models/fields/UpdateFieldRequest";
import { CreateTableRequest } from "../../models/tables/CreateTableRequest";
import { DeleteTableRequest } from "../../models/tables/DeleteTableRequest";
import { GetTablesRequest } from "../../models/tables/GetTablesRequest";
import { UpdateTableRequest } from "../../models/tables/UpdateTableRequest";
import { Entity } from "../../models/entities/Entity";
import { Table } from "../../models/tables/Table";
import { FieldType } from "../../models/fields/FieldType";
import { FieldSubType } from "../../models/fields/FieldSubType";

const MAPPING_RESOURCE_NAME = "tablemapping";
const PROJECT_SETUP_RESOURCE_NAME = "ProjectConfig";
const TABLES_RESOURCE_NAME = "tables";
const TABLE_FIELDS_RESOURCE_NAME = "tablefields";

const getToTableView = (model: any) => {
  const http = getAxiosInstance();
  if (model.rowsToShow) {
    return http.get(`${MAPPING_RESOURCE_NAME}/getToTableView?entity=${model.entity}&groupcode=${model.groupcode}&operation=${model.operation}&tableName=${encodeURIComponent(model.tableName).replace("(", "%28").replace(")", "%29")}&databaseName=${encodeURIComponent(model.databaseName).replace("(", "%28").replace(")", "%29")}&schemaName=${encodeURIComponent(model.schemaName).replace("(", "%28").replace(")", "%29")}&rowsToShow=${model.rowsToShow}`, requestConfig());
  }
  return http.get(`${MAPPING_RESOURCE_NAME}/getToTableView?entity=${model.entity}&groupcode=${model.groupcode}&operation=${model.operation}&tableName=${encodeURIComponent(model.tableName).replace("(", "%28").replace(")", "%29")}&databaseName=${encodeURIComponent(model.databaseName).replace("(", "%28").replace(")", "%29")}&schemaName=${encodeURIComponent(model.schemaName).replace("(", "%28").replace(")", "%29")}`, requestConfig());
};

const downloadTableViewData = (model: any) => {
  const http = getAxiosInstance();
  let config: AxiosRequestConfig = requestConfig();
  config.responseType = "blob";

  if (model.rowsToShow) {
    return http.get(
      `${MAPPING_RESOURCE_NAME}/downloadToTableView?entity=${model.entity
      }&groupcode=${model.groupcode}&operation=${model.operation
      }&tableName=${encodeURIComponent(model.tableName)
        .replace("(", "%28")
        .replace(")", "%29")}&rowsToShow=${model.rowsToShow}`,
      config
    );
  }
  return http.get(
    `${MAPPING_RESOURCE_NAME}/downloadToTableView?entity=${model.entity
    }&groupcode=${model.groupcode}&operation=${model.operation
    }&tableName=${encodeURIComponent(model.tableName)
      .replace("(", "%28")
      .replace(")", "%29")}`,
    config
  );
};

const getAllExportLoadfileConfiguration = () => {
  const http = getAxiosInstance();
  let config: AxiosRequestConfig = requestConfig();
  return http.get(
    "tablemapping/GetAllExportLoadfileConfiguration",
    requestConfig()
  );
};

const getExportLoadfileConfigurationFields = (configurationId?: number) => {
  const http = getAxiosInstance();
  let config: AxiosRequestConfig = requestConfig();

  return http.get(
    `${MAPPING_RESOURCE_NAME}/GetExportLoadfileConfigurationFields?configurationId=${configurationId}`, config);
};

const saveExportLoadfileConfiguration = (model: any) => {
  const http = getAxiosInstance();
  return http.post(
    `${MAPPING_RESOURCE_NAME}/CreateExportLoadfileConfiguration`,
    model,
    requestConfig()
  );
};

const updateExportLoadfileConfiguration = (id: number, model: any) => {
  const http = getAxiosInstance();
  return http.put(
    `${MAPPING_RESOURCE_NAME}/UpdateExportLoadfileConfiguration/${id}`,
    model,
    requestConfig()
  );
};

const createExportLoadfileConfigurationField = (configurationId: number, model: any) => {
  const http = getAxiosInstance();
  return http.post(
    `${MAPPING_RESOURCE_NAME}/CreateExportLoadfileConfigurationField/${configurationId}`,
    model,
    requestConfig()
  );
};

const updateExportLoadfileConfigurationField = (configurationId: number, fieldId: number, model: any) => {
  const http = getAxiosInstance();
  return http.put(
    `${MAPPING_RESOURCE_NAME}/UpdateExportLoadfileConfigurationField/${configurationId}/${fieldId}`,
    model,
    requestConfig()
  );
};



const exportLoadfile = (model: any) => {
  const http = getAxiosInstance();
  let config: AxiosRequestConfig = requestConfig();
  config.responseType = "blob";

  return http.post(`${MAPPING_RESOURCE_NAME}/ExportLoadfile`, model, config);
};

const recreateTable = (model: any) => {
  const http = getAxiosInstance();
  return http.post(
    `${MAPPING_RESOURCE_NAME}/recreateTable`,
    model,
    requestConfig()
  );
};

const downloadRecreateTableExcel = (model: any) => {
  const http = getAxiosInstance();
  let config: AxiosRequestConfig = requestConfig();
  config.responseType = "blob";

  return http.post(
    `${MAPPING_RESOURCE_NAME}/downloadRecreateTableTemplate`,
    model,
    config
  );
};

const importRecreateTableFromExcel = (model: any) => {
  const http = getAxiosInstance();
  const formData = new FormData();
  formData.append("file", model.file);
  formData.append("tableId", model.tableId);

  return http.post(
    `${MAPPING_RESOURCE_NAME}/uploadRecreateTableFromExcel`,
    formData,
    requestConfig()
  );
};

const importRecreateTableFromTable = (model: any) => {
  const http = getAxiosInstance();
  let config: AxiosRequestConfig = requestConfig();
  // config.responseType = 'blob';

  return http.get(
    `${MAPPING_RESOURCE_NAME}/uploadRecreateTableFromTable?fromTableId=${model.fromTableId}`,
    config
  );
};

const getAllEntities = (groupCode: string = null) => {
  const http = getAxiosInstance();
  if (groupCode !== null) {
    return http.get<Entity[]>(
      `${MAPPING_RESOURCE_NAME}/getAllEntities?groupCode=${groupCode}`,
      requestConfig()
    );
  }
  return http.get<Entity[]>(
    `${MAPPING_RESOURCE_NAME}/getAllEntities`,
    requestConfig()
  );
};

const getAllEntitiesPerGroupCode = (groupCode: string = null) => {
  const http = getAxiosInstance();
  if (groupCode !== null) {
    return http.get<Entity[]>(
        `${MAPPING_RESOURCE_NAME}/getAllEntitiesPerGroupCode?groupCode=${groupCode}`,
        requestConfig()
    );
  }
  return http.get<Entity[]>(
      `${MAPPING_RESOURCE_NAME}/getAllEntitiesPerGroupCode`,
      requestConfig()
  );
};


const getEntitySourcesCount = () => {
  const http = getAxiosInstance();
  return http.get(
    `${MAPPING_RESOURCE_NAME}/GetEntitySourcesCount`,
    requestConfig()
  );
};

const getAllOperations = () => {
  const http = getAxiosInstance();
  return http.get(`${MAPPING_RESOURCE_NAME}/getAllOperations`, requestConfig());
};

const getAllTranslations = () => {
  const http = getAxiosInstance();
  return http.get(
    `${MAPPING_RESOURCE_NAME}/getAllTranslations`,
    requestConfig()
  );
};

const getTranslationAtrributes = (groupCode) => {
  const http = getAxiosInstance();
  const url = groupCode
    ? `${MAPPING_RESOURCE_NAME}/getTranslationAtrributes?groupCode=${groupCode}`
    : `${MAPPING_RESOURCE_NAME}/getTranslationAtrributes`;
  return http.get(url, requestConfig());
};

const getAllReferences = () => {
  const http = getAxiosInstance();
  return http.get(`${MAPPING_RESOURCE_NAME}/getAllReferences`, requestConfig());
};

const getAllFromTables = (groupCode: string) => {
  const http = getAxiosInstance();
  return http.get(
    `${TABLES_RESOURCE_NAME}/from?groupCode=${groupCode}`,
    requestConfig()
  );
};

const getTables = (model: GetTablesRequest) => {
  const http = getAxiosInstance();
  if (model) {
    return http.get<Table[]>(
      `${MAPPING_RESOURCE_NAME}/getToTables?entityId=${model.entityId}&operationId=${model.operationId}&groupCode=${model.groupCode}`,
      requestConfig()
    );
  }

  return http.get<Table[]>(`${MAPPING_RESOURCE_NAME}/getToTables`, requestConfig());
};

const getFields = (model: GetFieldsRequest) => {
  const http = getAxiosInstance();
  return http.get(
    `${MAPPING_RESOURCE_NAME}/getAllFields?tableId=${model.tableId}`,
    requestConfig()
  );
};

const getFieldTypes = () => {
  const http = getAxiosInstance();
  return http.get<FieldType[]>(`${MAPPING_RESOURCE_NAME}/getFieldTypes`, requestConfig());
};

const getFieldSubtypes = () => {
  const http = getAxiosInstance();
  return http.get<FieldSubType[]>(`${MAPPING_RESOURCE_NAME}/getFieldSubtypes`, requestConfig());
};

const getValidationField = (fieldId: number) => {
  const http = getAxiosInstance();
  return http.get(
    `${MAPPING_RESOURCE_NAME}/getValidationField?fieldId=${fieldId}`,
    requestConfig()
  );
};

const getAllFromTableFields = (id: number) => {
  const http = getAxiosInstance();
  return http.get(
    `${TABLE_FIELDS_RESOURCE_NAME}/from?fromTableId=${id}`,
    requestConfig()
  );
};

const getAllToTableFields = (id: number) => {
  const http = getAxiosInstance();
  return http.get(
    `${TABLE_FIELDS_RESOURCE_NAME}/to?toTableId=${id}`,
    requestConfig()
  );
};

const getAllFromTablesWithFields = (model: GetTablesRequest) => {
  const http = getAxiosInstance();
  return http.get(
    `${TABLES_RESOURCE_NAME}/fromWithFields?groupCode=${model.groupCode}&entity=${model.entityId}`,
    requestConfig()
  );
};

const createTable = (model: CreateTableRequest) => {
  const http = getAxiosInstance();
  return http.post(
    `${MAPPING_RESOURCE_NAME}/createToTable`,
    model,
    requestConfig()
  );
};

const updateTable = (model: UpdateTableRequest) => {
  const http = getAxiosInstance();
  return http.put(
    `${MAPPING_RESOURCE_NAME}/updateToTable/${model.id}`,
    model,
    requestConfig()
  );
};

const deleteTable = (model: DeleteTableRequest) => {
  const http = getAxiosInstance();
  return http.delete(
    `${MAPPING_RESOURCE_NAME}/deleteToTable/${model.id}`,
    requestConfig()
  );
};

const createField = (model: CreateFieldRequest) => {
  const http = getAxiosInstance();
  return http.post(
    `${MAPPING_RESOURCE_NAME}/createField`,
    model,
    requestConfig()
  );
};

const updateField = (model: UpdateFieldRequest) => {
  const http = getAxiosInstance();
  return http.put(
    `${MAPPING_RESOURCE_NAME}/updateField/${model.id}`,
    model,
    requestConfig()
  );
};

const updateFieldPositions = (model: any) => {
  const http = getAxiosInstance();
  return http.put(
    `${MAPPING_RESOURCE_NAME}/updateFieldPositions`,
    model,
    requestConfig()
  );
};

const deleteField = (model: DeleteFieldRequest) => {
  const http = getAxiosInstance();
  return http.delete(
    `${MAPPING_RESOURCE_NAME}/deleteField/${model.id}`,
    requestConfig()
  );
};

const createEntity = (model: CreateEntityRequest) => {
  const http = getAxiosInstance();
  return http.post(
    `${MAPPING_RESOURCE_NAME}/createEntity`,
    model,
    requestConfig()
  );
};

const updateEntity = (model: UpdateEntityRequest) => {
  const http = getAxiosInstance();
  return http.put(
    `${MAPPING_RESOURCE_NAME}/updateEntity/${model.id}`,
    model,
    requestConfig()
  );
};

const updateEntityAccessRights = (model: any) => {
  const http = getAxiosInstance();
  return http.post(
    `${PROJECT_SETUP_RESOURCE_NAME}/SaveEntityAccessRight`,
    model,
    requestConfig()
  );
};

const updateGroupCodeAccessRights = (model: any) => {
  const http = getAxiosInstance();
  return http.post(
    `${PROJECT_SETUP_RESOURCE_NAME}/SaveGroupCodeAccessRight`,
    model,
    requestConfig()
  );
};

const deleteEntity = (model: DeleteEntityRequest) => {
  const http = getAxiosInstance();
  return http.delete(
    `${MAPPING_RESOURCE_NAME}/DeleteEntity/${model.id}`,
    requestConfig()
  );
};

const getAllTargetTables = () => {
  const http = getAxiosInstance();
  return http.get(`${TABLES_RESOURCE_NAME}/to`, requestConfig());
};
const scanTable = (tableId: number, entity: string) => {
  const http = getAxiosInstance();
  return http.post(
    `/TableMapping/ScanTable`,
    { tableId, entity },
    requestConfig()
  );
};

const TablesService = {
  getToTableView,
  downloadTableViewData,
  getAllEntities,
  getAllEntitiesPerGroupCode,
  getAllOperations,
  getAllTranslations,
  getAllReferences,
  getAllFromTables,
  getAllFromTablesWithFields,
  getAllFromTableFields,
  getAllToTableFields,
  getAllTargetTables,
  getTables,
  createTable,
  updateTable,
  deleteTable,
  getFields,
  getFieldTypes,
  getFieldSubtypes,
  getValidationField,
  createField,
  updateField,
  updateFieldPositions,
  deleteField,
  createEntity,
  updateEntity,
  deleteEntity,
  updateEntityAccessRights,
  updateGroupCodeAccessRights,
  downloadRecreateTableExcel,
  importRecreateTableFromExcel,
  importRecreateTableFromTable,
  recreateTable,
  getTranslationAtrributes,
  getEntitySourcesCount,
  scanTable,
  getAllExportLoadfileConfiguration,
  getExportLoadfileConfigurationFields,
  saveExportLoadfileConfiguration,
  updateExportLoadfileConfiguration,
  createExportLoadfileConfigurationField,
  updateExportLoadfileConfigurationField,
  exportLoadfile,
};
export default TablesService;
